import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query'

type BaseQuery = (
  args: string | FetchArgs,
) => ReturnType<BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>>

// Shared by reorder/look mutations: each block update becomes its own
// full-body PUT request, in the given order.
export const blockPutRequests = <T>(
  updates: ReadonlyArray<{ id: number; body: T }>,
  toBody: (body: T) => unknown,
): Array<{ url: string; body: unknown }> =>
  updates.map((u) => ({ url: `gamified-courses/blocks/${u.id}`, body: toBody(u.body) }))

// Shared queryFn body for reorder mutations: the backend has no bulk endpoint,
// so each changed entity gets its own full-body PUT. Sequential on purpose —
// it keeps rate pressure bounded and leaves a consistent prefix on failure.
export async function runSequentialPuts(
  baseQuery: BaseQuery,
  requests: ReadonlyArray<{ url: string; body: unknown }>,
): Promise<{ data: undefined } | { error: FetchBaseQueryError }> {
  for (const { url, body } of requests) {
    const res = await baseQuery({ url, method: 'PUT', body })
    if (res.error) return { error: res.error }
  }
  return { data: undefined }
}
